module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ga-Ha-Ic-Ja.47b1b7c6.png";